import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('company', { $company: 'company' })
  },
  methods: {
    ...mapActions('company', ['getCompanyItemCategories', 'getCompanyJobNSubJobStage', 'getCompanySetting', 'getCompanyInfo', 'setItemAutoCompleteEnabled', 'alterCompanySettings'])
  }
}
